import React, { useContext, useState } from "react";
import { LeadData } from "./VayuLead";
import VayuTableHeader from "./VayuTableHeader";
import moment from "moment";
import VayuLeadActivityLog from "./VayuLeadActivityLog";
import CardTabs from "modules/common/card-tabs/CardTabs";

function VayuContent() {
  const { doc } = useContext(LeadData);
  const [activeTab, setActiveTab] = useState();
  const tabStyle = { height: "30.5rem" };

  function sortData(responses) {
    const data = responses
      ?.sort((responseA, responseB) => {
        return new Date(responseA.createdAt) - new Date(responseB.createdAt);
      })
      .reduce((acc, response) => {
        const synId = response.synthetic_id;
        acc[synId] = acc[synId] || [];
        acc[synId].push({
          displayDate: moment(response.updatedAt).format(
            "MMM Do YYYY, h:mm a"
          ),
          ...response,
        });
        return acc;
      }, {});
    const sortedData = Object.values(data)?.reduce((acc, entry) => {
      const date = entry[0].displayDate;
      acc[date] = entry;
      return acc;
    }, {});
    return sortedData;
  }

  const tabs = {
    "form response": (
      <div style={tabStyle} className="scrollable-section">
        {doc?.form_responses?.length ? (
          <div className="side-sub-ab scrollable-container  shadow rounded">
            <VayuTableHeader
              dates={Object.keys(sortData(doc.form_responses))}
              setActiveTab={setActiveTab}
              doc={doc}
            />
            {Object.entries(sortData(doc.form_responses)).map(
              ([date, responses]) => {
                return (
                  date === activeTab && (
                    <div key={responses.displayDate}>
                      <div
                        style={{
                          height: "25.8rem",
                          overflowY: "scroll",
                        }}
                        className="mt-1 px-3 scrollable-container grid-container"
                      >
                        {responses.map((response) => {
                          return (
                            <div
                              key={response.id}
                              className="border rounded my-2 shadow"
                              style={{ padding: "1rem" }}
                            >
                              <p className="m-0 p-2 border-bottom">
                                {response.question}
                              </p>
                              <p className="m-0 p-2 text-success">
                                {response.reply}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )
                );
              }
            )}
          </div>
        ) : null}
      </div>
    ),
    "activity log": (
      <div style={tabStyle} className="scrollable-section">
        <VayuLeadActivityLog />
      </div>
    ),
  }

  return (
    <div>
      <CardTabs components={tabs} />
    </div>
  );
}

export default VayuContent;
